module.exports = __webpack_public_path__ + "static/media/judge-denny.9bfb8fdc.jpg";